var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5794 3.89027H26.6075V2.90247H38.5794V3.89027Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5794 13.7683H29.7113V12.7805H38.5794V13.7683Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5794 23.6464H26.6075V22.6586H38.5794V23.6464Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5794 3.89027H26.6075V2.90247H38.5794V3.89027Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5794 13.7683H29.7113V12.7805H38.5794V13.7683Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5794 23.6464H26.6075V22.6586H38.5794V23.6464Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6065 9.96688C24.6065 14.3979 20.9759 18.0069 16.4763 18.0069C11.9767 18.0069 8.34608 14.3979 8.34608 9.96688C8.34608 5.53585 11.9767 1.92688 16.4763 1.92688C20.9759 1.92688 24.6065 5.53585 24.6065 9.96688Z",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.668228 23.5432L9.88 14.5093L11.9594 16.588L2.74764 25.6219L0.668228 23.5432Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_410",
    x1: 0.908875,
    y1: 1.92688,
    x2: 25.6822,
    y2: 2.19231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#142FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B406B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.448d2527b69f19bf293045d0acfb29c6.svg";
export { ForwardRef as ReactComponent };